
const SHORT_BASE = 'aresLoan-mbBanking.products.loansAndMortgages.productContracting.02_LoanContracting.';
const BASE = `${SHORT_BASE}mbWizard.`;

export default {
  BASE,
  TITLE: `${BASE}confirmationTitle`,
  DESCRIPTION: `${BASE}confirmationDescription01`,
  TERMS_LABEL_DESCRIPTION:`${BASE}timeLimitLabelDescription`,
  COM_TITLE: `${BASE}communicationManagementSubtitle`,
  COM_DESCRIPTION: `${BASE}communicationManagementDescription`,
  LEGAL_INFO_TITLE: `${BASE}readAndAcceptLegalInfoTitle`,
  LEGAL_INFO_DESCRIPTION: `${BASE}readAndAcceptLegalInfoDescription`,
  LEGAL_INFO_BUTTON: `${BASE}readButton`,
  LEGAL_INFO_READ_BUTTON: `${BASE}alreadyReadButton`,
  CONTRACT_VIEWER_TITLE: `${SHORT_BASE}mbLegalContract.title`,
  PDF_VIEWER_CHECKBOX: `${SHORT_BASE}mbLegalViewer.modalIneDescription`,
};
